import { Link } from "react-router-dom";
import {
  Header,
  Card,
  SpeedSelect,
  Text,
  Space
} from "../../Components/Index";

import user from "../../../src/assets/Icon/User.svg";
import add from "../../../src/assets/Icon/add.svg";
import List from "../../../src/assets/Icon/List.svg";
import ServicePerformance from "./components/ServicePerformance";
import useServiceDashboardStats from "./components/useServiceDashboardStats";

function ServiceDashbord() {
  const { stats, loading, error, reload } = useServiceDashboardStats();

  return (
    <main className="service-dashboard" dir="rtl">
      <Header Text="داشبورد سرویس‌کار" />

      <div className="service-dashboard__content">
        <ServicePerformance
          stats={stats}
          loading={loading}
          error={error}
          onRetry={reload}
        />

        <Space />

        <Card className="service-dashboard__quick-access">
          <div className="service-dashboard__quick-heading">
            <Text FontWight="Bold" position="right">
              دسترسی سریع
            </Text>
          </div>

          <div className="service-dashboard__quick-grid">
            <Link className="Link" to="/UserPanel" aria-label="ورود به پنل کاربری">
              <SpeedSelect src={user} text="پنل کاربری" />
            </Link>
            <Link className="Link service-dashboard__quick-primary" to="/PlateCapture" aria-label="ثبت سرویس جدید">
              <SpeedSelect src={add} text="ثبت سرویس" />
            </Link>
            <Link className="Link" to="/Customers" aria-label="مشاهده مشتری‌ها">
              <SpeedSelect src={List} text="مشتری‌ها" />
            </Link>
          </div>
        </Card>
      </div>
    </main>
  );
}
export default ServiceDashbord;
